import { css } from '@emotion/react';
import type { ComponentPropsWithoutRef } from 'react';

import { theme } from '@adflow/frontend/ui-theme';

import { ButtonIconDelete } from './ButtonIconDelete';

const styles = {
	inlineButton: css({
		backgroundColor: theme.colors.white,
		display: 'grid',
		width: '2rem',
		height: '2rem',
		cursor: 'pointer',
		placeItems: 'center',
		borderBottomLeftRadius: '0.375rem',
		borderBottomRightRadius: '0.375rem',

		filter: 'drop-shadow(0px 8px 12px #0000001f);',
	}),
};

export function ButtonIconDeleteInline(props: ComponentPropsWithoutRef<'div'>) {
	return (
		<div {...props} css={styles.inlineButton}>
			<ButtonIconDelete />
		</div>
	);
}
